import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { colors } from "@mui/material";
function QuestionPaper({questions , withAnswers }) {
 
  return (
    <Box>
      {questions.map((question, qIndex) => (
        <Box
          sx={{ width: "100%", padding: 2, borderBottom: "1px solid #ccc" }}
          key={qIndex}
          mb={3}
        >
          {/* Question */}
          <p
            style={{ fontWeight: "bold", color: "black", marginBottom: "10px" }}
          >
            Question No. {qIndex + 1}
          </p>
          <Box
            sx={{
              "& img": {
                width: "80%",
                objectFit: "contain",
              },
            }}
            dangerouslySetInnerHTML={{ __html: question.question_en }}
            mb={1}
          />
          <Box
            style={{
              color: "black",
              display: "flex",
              gap: "10px",
              marginBottom: "10px",
            }}
          >
            <div>
              Question Type:{" "}{question.question_type};
              {/* <span style={{ fontWeight: "bold", color: "black" }}>
                {question.question_type !== "Fill In The Blanks"
                  ? "MCQ"
                  : question.question_type}
                ;
              </span> */}
            </div>
            <div>
              Marks for correct answer:{" "}
              <span
                style={{ fontWeight: "bold", color: "black", color: "green" }}
              >
                {question.mark};
              </span>
            </div>
            <div>
              Negative marks:{" "}
              <span
                style={{ fontWeight: "bold", color: "black", color: "red" }}
              >
                {question.negative_mark}
              </span>
            </div>
          </Box>
          {/* Options */}
          {question.question_type !== "Fill In The Blanks" && (
            <Box display="flex" flexDirection="column" gap={1}>
              {question.options.map((option, oIndex) => (
                <Box
                  key={oIndex}
                  display="flex"
                  alignItems="center"
                  gap={1}
                  sx={{
                    "& img": {
                      // width: "100px",
                      // height: "50px",
                      objectFit: "contain",
                    },
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: 1,
                  }}
                >
                  <span style={{ fontWeight: "bold", color: "black" }}>{`${
                    oIndex + 1
                  }`}</span>{" "}
                  <Box dangerouslySetInnerHTML={{ __html: option.option_en }} />
                </Box>
              ))}
            </Box>
          )}
          {withAnswers && (
            <div>
              {question.question_type !== "Fill In The Blanks" ? (
                <Box display="flex" flexDirection="column" gap={1}>
                  <span
                    style={{ fontWeight: "bold", color: "black" }}
                  >{`Correct Answer`}</span>{" "}
                  {question.options.map(
                    (option, oIndex) =>
                      option.correct_option && (
                        <Box
                          key={oIndex}
                          display="flex"
                          alignItems="center"
                          gap={1}
                          sx={{
                            "& img": {
                              width: "50px",
                              height: "50px",
                              objectFit: "contain",
                            },
                            display: "flex",
                            alignItems: "center",
                            paddingBottom: 1,
                          }}
                        >
                          <span
                            style={{ fontWeight: "bold", color: "black" }}
                          >{`${oIndex + 1}`}</span>{" "}
                          <Box
                            dangerouslySetInnerHTML={{
                              __html: option.option_en,
                            }}
                          />
                        </Box>
                      )
                  )}
                </Box>
              ) : (
                <Box style={{ fontWeight: "bold", color: "black" }}>
                  <span
                    style={{ fontWeight: "bold", color: "black" }}
                  >{`Correct Answer`}</span>{" "}
                  {question.options[0].solution_en}
                </Box>
              )}
            </div>
          )}
        </Box>
      ))}
    </Box>
  );
}
export default QuestionPaper;